import { render } from "./AddBranch.vue?vue&type=template&id=0deefefb&scoped=true"
import script from "./AddBranch.vue?vue&type=script&lang=js"
export * from "./AddBranch.vue?vue&type=script&lang=js"

import "./AddBranch.vue?vue&type=style&index=0&id=0deefefb&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0deefefb"]])

export default __exports__